<template>
  <el-dialog
    :visible.sync="showDeleteRedundantPhotoOnServer"
    width="1180px"
    custom-class="modern-dialog"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :show-close="false"
    top="4vh"
    @open="handleOpen"
  >
    <!-- 1. Themed Header (Deep Blue Gradient) -->
    <div class="dialog-header-themed">
      <div class="themed-left">
        <div class="themed-icon warning-icon"><i class="el-icon-brush"></i></div>
        <div class="themed-text">
          <div class="title-row">
            <h3>CHỌN TRƯỜNG DỌN DẸP ẢNH THỪA TRÊN HỆ THỐNG</h3>
          </div>
          <p>Quét và giải phóng các tệp ảnh rác hoặc không còn tham chiếu trong cơ sở dữ liệu của các trường được chọn</p>
        </div>
      </div>
      <div class="themed-close" @click="closeDialogByButton">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 2. Content Area -->
    <div class="modern-dialog-content">
      <!-- Section: Search Filters -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-search"></i> BỘ LỌC TÌM KIẾM TRƯỜNG</h4>
        <div class="filter-row">
          <el-select
            v-model="dataSearch.active"
            size="small"
            placeholder="Trạng thái kích hoạt"
            clearable
            style="width: 180px"
            @change="searchHeaderMethod"
          >
            <el-option
              v-for="item in statusAccountList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            />
          </el-select>

          <el-select
            v-model="dataSearch.deleteStatus"
            size="small"
            placeholder="Trạng thái xóa"
            clearable
            style="width: 170px"
            @change="searchHeaderMethod"
          >
            <el-option
              v-for="item in deleteList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            />
          </el-select>

          <el-input
            v-model="dataSearch.nameSchool"
            size="small"
            placeholder="Nhập tên trường học..."
            clearable
            style="width: 280px"
            @clear="searchHeaderMethod"
            @keyup.enter.native="searchHeaderMethod"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchHeaderMethod"
            />
          </el-input>
        </div>
      </div>

      <!-- Section: School Transfer List -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-files"></i> DANH SÁCH TRƯỜNG CẦN DỌN DẸP</h4>
        <div class="transfer-wrapper" v-loading="loadingDataDelete" element-loading-text="Đang tải danh sách trường...">
          <el-transfer
            v-model="dataTarget"
            filterable
            filter-placeholder="Tìm trường trong danh sách..."
            :titles="[
              `Tất cả trường (${dataSource.length})`,
              `Trường được dọn dẹp (${dataTarget.length})`
            ]"
            :button-texts="['Bỏ chọn', 'Chọn dọn']"
            :data="dataSource"
          >
            <span slot-scope="{ option }">{{ option.label }}</span>
          </el-transfer>
        </div>
      </div>

      <!-- Section: Time & Condition Configuration -->
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-date"></i> THIẾT LẬP THỜI GIAN & ĐIỀU KIỆN DỌN DẸP</h4>
        <div class="config-grid">
          <div class="config-item">
            <span class="config-label"><i class="el-icon-date"></i> Năm áp dụng <span class="required">*</span>:</span>
            <el-select
              v-model="years"
              size="small"
              placeholder="Chọn năm"
              style="width: 140px"
            >
              <el-option
                v-for="item in listYears"
                :key="item"
                :value="item"
                :label="item"
              />
            </el-select>
          </div>

          <div class="config-item">
            <span class="config-label"><i class="el-icon-time"></i> Các tháng áp dụng <span class="required">*</span>:</span>
            <el-select
              v-model="months"
              size="small"
              placeholder="Chọn các tháng"
              multiple
              collapse-tags
              style="width: 260px"
            >
              <el-option
                v-for="item in listMonth"
                :key="item.key"
                :value="item.key"
                :label="item.label"
              />
            </el-select>
          </div>

          <div class="config-item-check">
            <el-checkbox v-model="checkExitServer">
              <span class="checkbox-text">
                <i class="el-icon-coin"></i> Kiểm tra đối chiếu ảnh thừa với cơ sở dữ liệu trước khi xóa
              </span>
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. Themed Footer -->
    <div class="dialog-footer-themed">
      <el-button size="medium" @click="closeDialogByButton">
        <i class="el-icon-close"></i> Đóng
      </el-button>
      <el-button
        size="medium"
        class="gradient-btn purple-btn"
        icon="el-icon-brush"
        :disabled="dataTarget.length === 0"
        :loading="loadingButton"
        @click="deleteRedundantPhotos"
      >
        Tiến hành dọn ảnh thừa ({{ dataTarget.length }} trường)
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ManageDataService from "@/services/AdminService/ManageDataService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "DeleteRedundantPhotosDialog",
  props: {
    showDeleteRedundantPhotoOnServer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusAccountList: [
        { key: true, value: "Đã kích hoạt" },
        { key: false, value: "Chưa kích hoạt" },
      ],
      deleteList: [
        { key: true, value: "Chưa xóa" },
        { key: false, value: "Đã xóa" },
      ],
      dataSearch: {
        deleteStatus: true,
        active: true,
        nameSchool: "",
      },
      listMonth: [
        { key: 1, value: 1, label: "Tháng 1" },
        { key: 2, value: 2, label: "Tháng 2" },
        { key: 3, value: 3, label: "Tháng 3" },
        { key: 4, value: 4, label: "Tháng 4" },
        { key: 5, value: 5, label: "Tháng 5" },
        { key: 6, value: 6, label: "Tháng 6" },
        { key: 7, value: 7, label: "Tháng 7" },
        { key: 8, value: 8, label: "Tháng 8" },
        { key: 9, value: 9, label: "Tháng 9" },
        { key: 10, value: 10, label: "Tháng 10" },
        { key: 11, value: 11, label: "Tháng 11" },
        { key: 12, value: 12, label: "Tháng 12" },
      ],
      listSchool: [],
      loadingDataDelete: false,
      dataSource: [],
      dataTarget: [],
      loadingButton: false,
      showMessageRunAction: false,
      months: [],
      years: null,
      listYears: [],
      checkExitServer: true,
    };
  },
  watch: {
    listSchool: {
      handler() {
        if (this.listSchool.length > 0) {
          setTimeout(() => {
            this.loadingDataDelete = false;
          }, 400);
        }
      },
    },
  },
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      const startYear = 2020;
      this.listYears = [];
      for (let year = startYear; year <= currentYear; year++) {
        this.listYears.push(year);
      }
    },
    async searchHeaderMethod() {
      this.loadingDataDelete = true;
      this.dataTarget = [];
      try {
        const res = await ManageDataService.searchSchoolTransfer(
          this.dataSearch.deleteStatus,
          this.dataSearch.active,
          this.dataSearch.nameSchool
        );
        this.listSchool = res.data.data.schoolList || [];
      } catch (err) {
        console.error(err);
      } finally {
        this.setDataSource();
        this.loadingDataDelete = false;
      }
    },
    handleOpen() {
      this.loadingDataDelete = false;
      this.searchHeaderMethod();
      this.generateYears();
    },
    closeDialog() {
      this.$emit("close");
      this.resetFormData();
      this.handleClear();
    },
    closeDialogByButton() {
      this.$emit("close");
      this.resetFormData();
      this.handleClear();
    },
    handleClear() {
      this.checkExitServer = true;
      this.dataSearch.nameSchool = "";
      this.dataSearch.active = true;
      this.dataSearch.deleteStatus = true;
      this.months = [];
      this.years = null;
      this.listYears = [];
    },
    resetFormData() {
      setTimeout(() => {
        this.dataSource = [];
        this.dataTarget = [];
      }, 300);
    },
    deleteRedundantPhotos() {
      if (this.months.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn ít nhất một tháng cần xóa!");
        return;
      }
      if (this.years === null) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn năm cần xóa!");
        return;
      }
      this.$confirm(
        `Bạn có chắc chắn muốn xóa ảnh thừa năm ${this.years} của ${this.dataTarget.length} trường được chọn?`,
        "Xác nhận xóa ảnh thừa",
        {
          confirmButtonText: "Đồng ý xóa",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      ).then(() => {
        this.$emit("childEvent", true);
        this.$emit("close");
        ManageDataService.deleteRedundantPhotos(
          this.years,
          this.months,
          this.checkExitServer,
          this.dataTarget
        )
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Đã bắt đầu tiến trình dọn ảnh thừa!");
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError("Có lỗi xảy ra, không thể thực hiện thao tác!");
            console.error(err);
          })
          .finally(() => {
            this.loadingButton = false;
            this.closeDialog();
          });
      });
    },
    setDataSource() {
      const dataResponse = [];
      this.listSchool.forEach((school) => {
        dataResponse.push({
          label: `${school.id} - ${school.schoolName}`,
          key: school.id,
        });
      });
      this.dataSource = dataResponse;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}

.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  position: relative;

  .themed-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .themed-icon {
      width: 44px;
      height: 44px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #ffffff;

      &.warning-icon {
        background: rgba(245, 158, 11, 0.25);
        border-color: rgba(245, 158, 11, 0.4);
        color: #fcd34d;
      }
    }

    .themed-text {
      .title-row {
        display: flex;
        align-items: center;
        gap: 10px;

        h3 {
          margin: 0;
          font-size: 17px;
          font-weight: 700;
          letter-spacing: 0.5px;
          color: #ffffff;
        }
      }

      p {
        margin: 4px 0 0 0;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }

  .themed-close {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: scale(1.05);
    }
  }
}

.modern-dialog-content {
  padding: 20px 24px;
  max-height: 68vh;
  overflow-y: auto;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;

  .section-divider {
    margin: 0 0 12px 0;
    font-size: 12.5px;
    font-weight: 700;
    color: #2563eb;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 6px;
  }
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.transfer-wrapper {
  display: flex;
  justify-content: center;

  /deep/ .el-transfer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-transfer-panel {
      width: 44%;
      border-radius: 8px;
      border: 1px solid #cbd5e1;

      .el-transfer-panel__header {
        background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
        color: #ffffff;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;

        .el-checkbox .el-checkbox__label {
          color: #ffffff;
          font-weight: 600;
          font-size: 13.5px;
        }
      }

      .el-transfer-panel__body {
        height: 320px;
      }

      .el-transfer-panel__filter {
        margin: 8px 10px;
        width: calc(100% - 20px);
      }

      .el-transfer-panel__list.is-filterable {
        height: 255px;
      }
    }

    .el-transfer__buttons {
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .el-button {
        margin: 0;
        border-radius: 6px;
      }
    }
  }
}

.config-grid {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;

  .config-item {
    display: flex;
    align-items: center;
    gap: 8px;

    .config-label {
      font-size: 13px;
      font-weight: 600;
      color: #334155;

      .required {
        color: #ef4444;
      }

      i {
        margin-right: 4px;
        color: #64748b;
      }
    }
  }

  .config-item-check {
    margin-left: auto;

    .checkbox-text {
      font-size: 13px;
      font-weight: 600;
      color: #1e293b;

      i {
        margin-right: 4px;
        color: #2563eb;
      }
    }
  }
}

.dialog-footer-themed {
  padding: 14px 24px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.gradient-btn {
  border: none !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-radius: 6px !important;
  transition: all 0.3s ease !important;

  &.purple-btn {
    background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%) !important;
    box-shadow: 0 4px 10px rgba(139, 92, 246, 0.3);
    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }
}
</style>
